import { PartnerAnalyticsView } from "@/components/partner/PartnerViews";

/** Reach / analytics — uses get_partner_reach_summary for live learner, view, and geo stats. */
const PartnerAnalytics = () => <PartnerAnalyticsView />;

export default PartnerAnalytics;
